import { basicInfoAtom } from "@/atoms"
import { formatDecimalBR } from "@/lib/format-decimal-br"
import { useAtomValue } from "jotai"

/**
 * Store minimum-order rule shared by FinishCartButton and FinishOrderButton.
 * `label` matches the historical inline `toFixed(2).replace('.', ',')`
 * output exactly (e.g. "12,50").
 */
export function useMinimumOrder() {
  const basicInfo = useAtomValue(basicInfoAtom)
  const minimum = basicInfo?.minOrderValue?.value ?? 0

  return {
    minimum,
    isBelowMinimum: (total: number) => total < minimum,
    label: formatDecimalBR(minimum),
  }
}
